if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // mcp adds
        this.cartHasSellingPlan = false;
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        //console.log('onSubmitHandler', event.target)
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (event.target.querySelector('input[name="selling_plan"]')) {
          this.cartHasSellingPlan = await this.getCartItems();
          //console.log('cartHasSellingPlan RES', this.cartHasSellingPlan)
          if (this.cartHasSellingPlan) {
            let errorMessageWrapper = this.querySelector('.shipping-modal-form__error-message-wrapper');
            if (errorMessageWrapper) {
              errorMessageWrapper.toggleAttribute('hidden', false);
            }
            this.submitButton.classList.remove('loading');
            this.submitButton.setAttribute('aria-disabled', true);
            this.querySelector('.loading__spinner').classList.add('hidden');
          } else {
            this.addItemToCart();
          }
        } else {
          this.addItemToCart();
        }
      }

      addItemToCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            //console.log('ADD TO CART', response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            // mcp adds
            const modal = this.closest('quick-add-modal') || this.closest('modal-dialog');
            if (modal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              modal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // mcp add
      async getCartItems() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        await fetch(`${routes.cart_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            //console.log('RES', response.items)
            if (response.item_count > 0) {
              let sellingPlanItems = response.items.filter(item =>
                item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.recurring_deliveries : false
              )
              sellingPlanItems.length > 0 ? this.cartHasSellingPlan = true : this.cartHasSellingPlan = false;
              //console.log('Check if cart as abo 2', this.cartHasSellingPlan)
            } else {
              this.cartHasSellingPlan = false;
            }
          })
          .catch((e) => {
            console.error(e);
          })
        return this.cartHasSellingPlan;
      }
      // end mcp adds

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
